import React from 'react';
import { Star } from 'lucide-react';
import { StarRating } from '@/components/StarRating';
import type { BookReviewStats as Stats } from '@/hooks/useBookReviews';

interface BookReviewStatsProps {
  stats: Stats;
}

export function BookReviewStats({ stats }: BookReviewStatsProps) {
  return (
    <div className="bg-muted/50 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-baseline gap-1">
            <span className="text-4xl font-bold">{stats.averageRating.toFixed(1)}</span>
            <Star className="w-6 h-6 fill-primary text-primary mb-1" />
          </div>
          <div className="text-sm text-muted-foreground">
            <div>out of 5</div>
            <div>{stats.totalRatings} {stats.totalRatings === 1 ? 'rating' : 'ratings'}</div>
          </div>
        </div>

        {/* Visual star representation */}
        <div className="hidden sm:block">
          <StarRating value={stats.averageRating} readonly size="md" />
        </div>
      </div>
    </div>
  );
}
